export function ApplicationLoading() {
  return <div className="grid min-h-dvh place-items-center bg-app-bg p-6 text-app-fg" role="status" aria-live="polite">
    <div className="space-y-2 text-center">
      <p className="font-display text-2xl text-app-fg-strong">Preparando a clínica…</p>
      <p className="text-sm">Aguarde enquanto carregamos a navegação.</p>
    </div>
  </div>;
}
